import { Button, Flex, Input, PasswordInput, Text } from '@components';
import { styled } from '@mui/material';

export const Subtitle = styled(Text)(({ theme }) => ({
  color: theme.palette.grey.A100,
}));

export const BackButton = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginLeft: `-${theme.spacing(6)}`,
}));

export const BoldedTextDisclaimer = styled('a')(({ theme }) => ({
  display: 'inline',
  color: theme.palette.primary.dark,
  fontWeight: 600,
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'underline',
  },
}));

export const StyledInput = styled(Input)(({ theme }) => ({
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: { flex: 1 },
  [theme.breakpoints.down('lg')]: {
    flex: '1 0 100%',
  },
}));

export const MultiInputContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  [theme.breakpoints.up('lg')]: { flexWrap: 'nowrap' },
  [theme.breakpoints.down('lg')]: { flexWrap: 'wrap' },
}));

export const StyledInputMargin = styled(StyledInput)(({ theme }) => ({
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: {
    marginRight: theme.spacing(6),
  },
  [theme.breakpoints.down('lg')]: {
    marginRight: 0,
  },
}));

export const StyledPasswordInput = styled(PasswordInput)(({ theme }) => ({
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('lg')]: {
    flex: 1,
    maxWidth: `calc(50% - ${theme.spacing(5)})`,
  },
  [theme.breakpoints.down('lg')]: {
    flex: '1 0 100%',
    width: '100%',
  },
}));
